export default __webpack_public_path__ + "static/media/cancer1.e9e96873.jpeg";